/**
 * Models a user's account data object
 */

import Brace from "backbone.brace";
import Roles from "../collections/account-roles";
import _ from "underscore";

const Model = Brace.Model.extend({
  namedAttributes: {
    id: Number,
    username: String,
    firstName: String,
    lastName: String,
    phone: String,
    enabled: Boolean,
    roles: Roles,
    receiveEmailNotifications: Boolean,
    useCalendarPopups: Boolean,
    invisible: Boolean,
    reportingPreferences: String,
    name: String,
    openChartsAssigned: Number,
  },
  stale: ["roles"],
  toJSON() {
    return _.omit(this.attributes, this.stale);
  },
});

export { Model as default };
